import { render, staticRenderFns } from "./ProfileButton.vue?vue&type=template&id=178367ef&scoped=true"
import script from "./ProfileButton.vue?vue&type=script&lang=js"
export * from "./ProfileButton.vue?vue&type=script&lang=js"
import style0 from "./ProfileButton.vue?vue&type=style&index=0&id=178367ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178367ef",
  null
  
)

/* custom blocks */
import block0 from "./ProfileButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports